import './TransactionHistory.less';
import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import moment from 'moment';
import i18n from '@i18n';
import BlockLoader from '@/ui/BlockLoader';
import InfiniteScroll from '@/responsive/components/InfiniteScroll/InfiniteScroll';
import { formatCurrency, formatMoney } from '@/common/client';
import { initTransactionHistory, loadMoreTransactionHistory } from '@/transactionHistory/handlers';
import {
    transactionHistoryCurrency$,
    transactionHistoryHasMore$,
    transactionHistoryReports$
} from '@/transactionHistory/subs';

function formatAmount(amount) {
    const value = `${amount
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$& ')
        .replace(/[\-]+/g, '$& ')} ${formatCurrency('NIK')}`;
    return amount > 0 ? `+ ${value}` : value;
}

function HistoryRow({ transaction }) {
    const momentDate = moment(transaction.date);
    const { subscribe } = useReframe();
    const reportsCurrency = subscribe(transactionHistoryCurrency$);
    let transactionType;
    if (transaction.type === 'reward' && transaction.referenceId.startsWith('bbr_')) {
        transactionType = 'bbr_reward';
    }

    return (
        <div className="spin-border">
            <div className="row cells">
                <div className="cell history-cell-30">
                    <span>{momentDate.format('DD.MM.YYYY HH:mm')}</span>
                </div>
                <div className="cell history-cell-35">
                    {i18n(
                        transactionType
                            ? `reports.text.${transactionType}`
                            : `reports.text.${transaction.type}.${reportsCurrency}`
                    )}
                </div>
                <div className="cell history-cell-35 amount">
                    <div className={transaction.amount > 0 ? 'green' : 'red'}>{formatAmount(transaction.amount)}</div>
                    {formatMoney(transaction.balance, 'NIK', 2)}
                </div>
            </div>
        </div>
    );
}

function TransactionHistory() {
    useEffect(() => {
        dispatch(initTransactionHistory);
    }, []);

    const { subscribe } = useReframe();
    const transactions = subscribe(transactionHistoryReports$);
    const hasMore = subscribe(transactionHistoryHasMore$);

    if (!transactions) {
        return null;
    }

    return (
        <div className="casino-history transaction-history">
            <span>{i18n('reports.text')}</span>

            <div className="history-table">
                <div className="cells-group">
                    <div className="spin-border sorting-row">
                        <div className="row cells">
                            <div className="cell history-cell-30">{i18n('cashin.reports.time')}</div>
                            <div className="cell history-cell-35">{i18n('cashin.reports.transaction')}</div>
                            <div className="cell history-cell-35 amount">{i18n('cashin.reports.balance')}</div>
                        </div>
                    </div>
                </div>
                <InfiniteScroll
                    className="cells-group"
                    loadMore={() => dispatch(loadMoreTransactionHistory)}
                    hasMore={hasMore}
                    threshold={0}
                    loader={<BlockLoader key="loader" />}
                    initialLoad={true}
                >
                    {transactions.map((transaction, index) => (
                        <HistoryRow key={index} transaction={transaction} />
                    ))}
                </InfiniteScroll>
            </div>
        </div>
    );
}

export default TransactionHistory;
